import {HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot,Resolve,RouterStateSnapshot,Routes} from '@angular/router';
import {Observable} from 'rxjs';
import {UserRouteAccessService} from 'src/app/core';
import {SubRuleMySuffix} from 'src/app/shared/model/subrule-my-suffix.model';
import {SubRuleMySuffixDetailComponent} from '.';
import {SubRuleMySuffixUpdateComponent} from './sub-rule-my-suffix-update.component';
import {SubRuleMySuffixService} from './sub-rule-my-suffix.service';



@Injectable({ providedIn: 'root' })
export class SubRuleMySuffixResolve implements Resolve<any> {
    constructor(private service: SubRuleMySuffixService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let id = route.params['id'] ? route.params['id'] : null;
        if(id==null){
            id = route.params['subRuleId'] ? route.params['subRuleId'] : null;
        }
        if (id) {
            if (state.url.includes('view')) {
                return this.service.get("api/sub-rule/"+id).map((subRule: HttpResponse<any>) => subRule);
            }
            return this.service.get("api/sub-rule/"+id).map((subRule: HttpResponse<any>) => subRule.body);
        }
        return Observable.of(new SubRuleMySuffix());
    }
}

export const subRuleRoute: Routes = [
//sub-rule-my-suffix
    {
        path: ':id/:ruleId/edit/:policyMarketType',
        component: SubRuleMySuffixUpdateComponent,
        resolve: {
            subrule: SubRuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'Sub-Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: ':id/:ruleId/edit/:policyMarketType/ots',
        component: SubRuleMySuffixUpdateComponent,
        resolve: {
            subrule: SubRuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'Sub-Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: ':id/:ruleId/edit/:policyMarketType/ots/:scopeId',
        component: SubRuleMySuffixUpdateComponent,
        resolve: {
            subrule: SubRuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'Sub-Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'new/:ruleId/:policyMarketType',
        component: SubRuleMySuffixUpdateComponent,
        resolve: {
            subrule: SubRuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Sub-Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'ots/:scopeId/:ruleId/:policyMarketType',
        component: SubRuleMySuffixUpdateComponent,
        resolve: {
            subrule: SubRuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Sub-Rules'
        },
        canActivate: [UserRouteAccessService]
    },

    {
        path: ':id/:ruleId/view/:policyMarketType',
        component: SubRuleMySuffixDetailComponent,
        resolve: {
            subrule: SubRuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'INSURER_AUDIT',
                'UNDERWRITER_AUDIT'
            ],
            pageTitle: 'Sub-Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'ots/:scopeId/:id/:ruleId/view/:policyMarketType',
        component: SubRuleMySuffixDetailComponent,
        resolve: {
            subrule: SubRuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'INSURER_AUDIT',
                'UNDERWRITER_AUDIT'
            ],
            pageTitle: 'Sub-Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: ':id/:ruleId/open-view',
        component: SubRuleMySuffixDetailComponent,
        resolve: {
            subrule: SubRuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'open-Sub-Rule'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: ':id/:ruleId/open-view/OPEN',
        component: SubRuleMySuffixDetailComponent,
        resolve: {
            subrule: SubRuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'open-Sub-Rule'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'ots/:scopeId/:id/:ruleId/open-view/OPEN',
        component: SubRuleMySuffixDetailComponent,
        resolve: {
            subrule: SubRuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'open-Sub-Rule'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'new/:ruleId/:policyMarketType/ots/:scopeId',
        component: SubRuleMySuffixUpdateComponent,
        resolve: {
            subrule: SubRuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Sub-Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'new/:subRuleId/:ruleId/:policyMarketType/ots/:scopeDataId',
        component: SubRuleMySuffixUpdateComponent,
        resolve: {
            subrule: SubRuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Sub-Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'new/:subRuleId/:ruleId/:policyMarketType/ots/:scopeDataId/:scopeId',
        component: SubRuleMySuffixUpdateComponent,
        resolve: {
            subrule: SubRuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Sub-Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'new/:id/:ruleId/:ots/:scopeId',
        component: SubRuleMySuffixUpdateComponent,
        resolve: {
            subrule: SubRuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Sub-Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'new/:id/:ruleId/:ots/:scopeId/:otherRule',
        component: SubRuleMySuffixUpdateComponent,
        resolve: {
            subrule: SubRuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Sub-Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'new/ots/:id/add',
        component: SubRuleMySuffixUpdateComponent,
        resolve: {
            subrule: SubRuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Sub-Rules',
        },
        canActivate: [UserRouteAccessService]
    },

    {
        path: 'new/:ruleId/:scopeId/:policyMarketType',
        component: SubRuleMySuffixUpdateComponent,
        resolve: {
            subrule: SubRuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Sub-Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    
];


